import request from '../utils/request'

export default {
  async lists(data) { // 获取商品列表
    const ret = await request('/v1/goods/lists', data, 'POST')
    return ret
  },

  async operate(data) { // 新增/编辑商品
    const ret = await request('/v1/goods/operate', data, 'POST')
    return ret
  },

  async getCategory(data) { // 获取商品分类
    const ret = await request('/v1/goods/getCategory', data, 'POST')
    return ret
  },

  async status(data) { // 修改商品状态
    const ret = await request('/v1/goods/status', data, 'POST')
    return ret
  },

  async delete(data) { // 删除商品
    const ret = await request('/v1/goods/delete', data, 'POST')
    return ret
  },

  async getModelList(data) { // 获取型号列表
    const ret = await request('/v1/deviceModel/selectList', data, 'POST')
    return ret
  }
}